import Vue from 'vue'
import Vuex from 'vuex'
import Moment from 'moment'
import { getToken, getOpenid, getShop, getTime, getStore, getStaff, getIsTime, getTenantId } from '@/libs/auth'

Vue.use(Vuex)

const state = {
  token: getToken(),
  openid: getOpenid(),
  shop: getShop(),
  store: getStore(),
  staff: getStaff(),
  isTime: getIsTime(),
  tenant_id: getTenantId(),
  time: getTime() || Moment().format('YYYY-MM')
}

const mutations = {
  SET_TIME: time => {
    state.time = time
  }
}

const actions = {
  onSetTime({ commit }, time) {
    commit('SET_TIME', time)
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})
